import { Link } from 'react-router-dom'
import { useI18n } from '../i18n/I18nProvider'
import { useSession } from '../session/SessionProvider'
import { Busy, Notice } from '../ui/controls'

export function AccountPage() {
  const { t } = useI18n()
  const { account } = useSession()

  if (!account) {
    return <Busy />
  }

  return (
    <div className="page stack">
      <h1>{t('account.title')}</h1>

      <section className="card stack">
        <div className="kv">
          <span>{t('account.email')}</span>
          <strong>{account.email}</strong>
        </div>

        <div className="kv">
          <span>{t('account.status')}</span>
          <strong>
            {account.emailConfirmed ? t('account.emailConfirmed') : t('account.emailUnconfirmed')}
          </strong>
        </div>
      </section>

      {account.emailConfirmed ? null : (
        <Notice>
          {t('verify.whyRequired')}{' '}
          <Link to={`/verify?email=${encodeURIComponent(account.email)}`}>{t('verify.resend')}</Link>
        </Notice>
      )}
    </div>
  )
}
